import {
    GET_FINANCIALS_FOR_POLICY,
    RECEIVE_FINANCIALS_FOR_POLICY,
    FAILED_TO_RECEIVE_FINANCIALS_FOR_POLICY
} from "./index";
import { actionCreator } from "../helpers/functions";

export const getFinancialsForPolicy = actionCreator(GET_FINANCIALS_FOR_POLICY);
export const receiveFinancialsForPolicy = actionCreator(RECEIVE_FINANCIALS_FOR_POLICY);
export const failedToReceiveFinancialsForPolicy = actionCreator(FAILED_TO_RECEIVE_FINANCIALS_FOR_POLICY);
